import { useEffect } from "react";
import useSiteMenuClone from "./helpers/navbar";
import { Link } from "react-router-dom";
import Footer from "../layouts/footer";
import Navbar from "../layouts/nav";

export default function CategoryHeader() {
    useEffect(() => {
		// List of JS files to reload
		const jsFiles = [
		  'assets/js/scrolltoTop.js',
		  'assets/js/custom.js',
		];
	
		// Create script elements for each JS file
		jsFiles.forEach((filePath) => {
		  const script = document.createElement('script');
		  script.src = filePath;
		  script.async = true;
		  document.body.appendChild(script);
		});
	
		// Clean up the script elements when the component unmounts
		return () => {
		  jsFiles.forEach((filePath) => {
			const script = document.querySelector(`[src="${filePath}"]`);
			if (script) {
			  document.body.removeChild(script);
			}
		  });
		};
	  }, []);

  return (
    <>

        

  <Navbar style={'#1A374D'} active={'dropdown'}></Navbar>

      <div id="collectionH_parallax-world-of-ugg">
        <section>
          <div className="collectionH_title">
            <h3>Creature Chronicles</h3>
            <h1>Today's Riveting Wildlife News</h1>
          </div>
        </section>

        <section>
          <div className="collectionH_parallax-one">
            <h2>Coral Reefs' Colorful Ballet</h2>
          </div>
        </section>

        <section>
          <div className="collectionH_block">
            <p>
              <span className="collectionH_first-character collectionH_sc">
                C
              </span>
              oral reefs, these captivating underwater rainforests, hold within
              their intricate ecosystems an astounding diversity of life that
              leaves us in awe. From the kaleidoscopic dance of vibrant fish to
              the graceful glide of mesmerizing sea turtles and the ethereal
              beauty of jellyfish, these submerged worlds are a treasure trove
              of marine marvels.
              <p>
                The magic of coral reefs lies in their symbiotic bond with tiny
                algae known as zooxanthellae. In a mesmerizing ballet of
                cooperation, the corals provide a safe haven for the algae,
                while the algae, in return, bestow the corals with their vibrant
                colors and vital nutrients, powering the reefs to thrive.
              </p>
            </p>
            <p className="collectionH_line-break collectionH_margin-top-10"></p>
            <p className="collectionH_margin-top-10">
              <p>
                However, amid this aquatic paradise, a looming crisis threatens
                these delicate ecosystems. Climate change-induced bleaching,
                driven by rising sea temperatures, poses one of the gravest
                threats to coral reefs. The once-vibrant hues of the corals fade
                as they expel their essential zooxanthellae, leading to their
                eventual demise.
              </p>
              <p>
                Moreover, the reckless hands of overfishing and pollution add to
                the reefs' plight, disturbing the natural balance and pushing
                these mesmerizing aquatic wonders to the brink of extinction.
              </p>
              <p>
                Yet, all hope is not lost. It is in these dire times that the
                clarion call for conservation rings louder than ever. The urgent
                need to raise awareness and take swift action to protect these
                ethereal sanctuaries becomes paramount. By fostering a deep
                understanding of their significance and fragility, we can rally
                the world to preserve these marvels for generations to come.
              </p>
            </p>
          </div>
        </section>

        <section>
          <div className="collectionH_parallax-two">
            <h2>Tigers - Grace and Power Combined</h2>
          </div>
        </section>

        <section>
          <div className="collectionH_block">
            <p>
              <span className="collectionH_first-character collectionH_ny">
                T
              </span>
              he world's wilderness, a magnificent and regal creature prowls with grace and power, leaving an indelible mark on the landscapes it calls home. The tiger, the largest of all big cats, has long captivated human imagination with its mesmerizing beauty and commanding presence. From the lush forests of India to the snow-capped mountains of Siberia, tigers roam through a diverse range of habitats, displaying a remarkable ability to adapt to different environments. 
            </p>
            <p>
            Beyond their captivating beauty, tigers play a crucial role in maintaining ecological balance within their habitats. As apex predators, they regulate prey populations, preventing overgrazing and maintaining the health of ecosystems. By controlling herbivore numbers, tigers indirectly influence plant growth and help preserve the delicate harmony of the natural world.
            </p>
            <p className="collectionH_line-break collectionH_margin-top-10"></p>
            <p className="collectionH_margin-top-10">
            However, tragically, despite their regal status, tigers face an uphill battle for survival. Human activities, such as deforestation, habitat fragmentation, and human-wildlife conflict, encroach upon their territories, leaving them with diminishing spaces to roam freely. Poaching remains one of the gravest threats to tiger populations. The demand for tiger body parts, driven by traditional medicine practices and the illegal wildlife trade, has led to a ruthless market that puts these magnificent creatures at risk of extinction. 
            </p>
            <p>
            In the face of these daunting challenges, a united global effort has emerged to protect these majestic guardians of the wild. Conservation organizations, governments, and passionate individuals work tirelessly to safeguard tiger habitats, enforce anti-poaching measures, and promote responsible ecotourism practices. Conservation breeding programs offer hope for endangered tiger species, working to reintroduce captive-bred tigers into the wild and increase their population numbers.
            </p>
          </div>
        </section>

        <section>
          <div className="collectionH_parallax-three">
            <h2>Orcas - The Intelligent Ocean Giants</h2>
          </div>
        </section>

        <section>
          <div className="collectionH_block">
            <p>
              <span className="collectionH_first-character collectionH_atw">
                O
              </span>
              rcas, commonly known as killer whales, are highly intelligent and social marine mammals. . Graceful and imposing, these magnificent marine mammals command attention with their distinctive black and white markings that contrast against the vast blue canvas of the sea. With an aura of mystery surrounding them, orcas have captured the imaginations of cultures across the globe, embodying both fascination and fear.
            </p>
            <p>
            Highly intelligent and remarkably social, orcas live in tight-knit family groups known as pods. Within these pods, complex relationships and intricate communication systems have evolved, allowing orcas to work together harmoniously in their aquatic realm. Their mesmerizing vocalizations, consisting of clicks, whistles, and songs, contribute to their ability to navigate, hunt, and communicate across great distances in the vast ocean expanse.
            </p>
            <p className="collectionH_line-break collectionH_margin-top-10"></p>
            <p className="collectionH_margin-top-10">
            Orcas' status as apex predators is undisputed, and their hunting prowess is nothing short of extraordinary. They are known for their cooperative hunting strategies, with pods collaborating to take down large marine prey, including seals, sea lions, and even other whales. Their unmatched intelligence and adaptability have earned them a place at the top of the marine food chain, where they play a crucial role in maintaining ecosystem balance. However, despite their mastery of oceanic domains, orcas, like many marine species, face a plethora of challenges. Habitat degradation, pollution, noise disturbance, and depletion of their prey due to overfishing threaten their survival. Furthermore, the capture and captivity of orcas for entertainment purposes have sparked widespread debate over their ethical treatment and the necessity of marine theme parks. The repercussions of these practices on orca populations, both in the wild and captivity, call for rigorous conservation efforts and greater public awareness. Safeguarding their marine habitats and preserving their delicate social structures are paramount in ensuring the survival of these oceanic monarchs and maintaining the delicate equilibrium of our marine ecosystems.
            </p>
          </div>
        </section>
      </div>

      <Footer/>
    </>
  );
}
